module.exports = __webpack_public_path__ + "media/components/country-flag/static/hn-e4953d7b732a30f97a13706fc34a9680.svg";